import { SVGProps } from 'react';

export const ClockIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M14.1625 6.21566C13.3236 5.3116 12.2266 4.73042 11.0005 4.60127C9.83893 4.40754 8.61285 4.73042 7.58035 5.44075C6.54786 6.15108 5.83802 7.18429 5.57989 8.41122C5.32177 9.57358 5.45083 10.8651 6.03161 11.8983C6.61239 12.9961 7.58035 13.8356 8.74191 14.223C9.32269 14.4167 9.90346 14.5459 10.4197 14.5459C11.065 14.5459 11.6458 14.4167 12.2911 14.223C13.4527 13.771 14.3561 12.9315 14.9369 11.7692L15.0014 11.7046C15.0014 11.64 15.0659 11.5754 15.0659 11.5108C15.3241 10.8651 15.4531 10.2193 15.4531 9.57358C15.4531 8.28207 15.0014 7.11971 14.1625 6.21566ZM14.4852 9.50901C14.4852 10.0256 14.3561 10.6068 14.1625 11.0588L14.0334 11.3171C13.5817 12.2212 12.8074 12.8669 11.9039 13.2544C11.0005 13.6418 9.968 13.6418 9.06456 13.319C8.16113 12.9961 7.38676 12.2858 6.87051 11.4463C6.41879 10.6068 6.28973 9.57358 6.54786 8.60495C6.74145 7.63632 7.32223 6.79684 8.16113 6.21566C8.87097 5.76363 9.64534 5.50532 10.4842 5.50532C10.6133 5.50532 10.8069 5.50532 10.936 5.50532C11.9039 5.63448 12.8074 6.0865 13.4527 6.86141C14.098 7.57174 14.4852 8.54037 14.4852 9.50901Z"
                fill="#6C6B6B"
            />
            <path
                d="M10.4836 9.77011V7.33777C10.4836 7.07947 10.29 6.88574 9.96734 6.88574C9.70922 6.88574 9.51562 7.07947 9.51562 7.33777V9.96384C9.51562 10.093 9.58016 10.2221 9.64469 10.2867L11.258 11.9011C11.3225 11.9657 11.4516 12.0303 11.5806 12.0303C11.7097 12.0303 11.8387 11.9657 11.9033 11.9011C12.0969 11.7074 12.0969 11.3845 11.9033 11.1908L10.4836 9.77011Z"
                fill="#6C6B6B"
            />
        </svg>
    );
};
